import styled from '@emotion/styled';
import { Text, H3 } from 'ds/components/typography';
import { colorToAlpha } from 'helpers/insight';

export const ModalContentRoot = styled.div<{ isMobile: boolean; }>`
  ${({ theme, isMobile }) => `
    display: flex;
    ${isMobile ? `
      flex-direction: column;
      align-items: center;
      gap: ${theme.spacing(3)};
    ` : `
      gap: ${theme.spacing(0.5)};
    `}
  `}
`;

export const ModalContentInfoSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 360px;
  margin: 0 auto;
`;

export const ModalContentBannerSection = styled.div``;

export const BannerImage = styled.img<{ isMobile: boolean; }>`
  ${({ theme, isMobile }) => `
    border-radius: ${theme.borderRadius.small};
    background: ${theme.colors.neutrals.grey8};
    ${isMobile ? `
      width: auto;
      max-width: 336px;
      height: 100px;
    ` : `
      width: 336px;
      height: 340px;
    `}
  `}
`;

export const HeaderTitle = styled(H3)`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey1};
    margin-bottom: ${theme.spacing(2)};
  `}
`;

export const Description = styled(Text)`
  text-align: center;
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey1};
    margin-bottom: ${theme.spacing(4)};
  `}
`;

export const SocialLink = styled.div`
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  ${({ theme }) => `
    box-shadow: ${theme.shadow.level2};
    background-color: ${theme.colors.neutrals.white};
    border: solid 1px ${theme.colors.neutrals.grey8};
    border-radius: ${theme.borderRadius.round};
    svg {
      path {
        fill: ${theme.colors.brand.main};
      }
    }
  `}
`;

export const SocialLinkWrapper = styled.span`
  cursor: pointer;
  margin-right: ${({ theme }) => theme.spacing(3)};
  &:first-of-type {
    margin-right: 0;
  }
`;

export const LinksWrapper = styled.div`
  display: flex;
`;

export const IconWrapper = styled.div`
  width: 88px;
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ theme }) => `
    border-radius: ${theme.borderRadius.round};
    background: ${colorToAlpha(theme.colors.brand.main, 0.07)};
    margin-bottom: ${theme.spacing(3)};
  `}
`;

export const CopyTooltip = styled.div`
  position: absolute;
  z-index: 2;
  left: 50%;
  bottom: calc(100% + 14px);
  transform: translateX(-50%);
  background: #074351;
  ${({ theme }) => `
    border-radius: ${theme.borderRadius.tiny};
    padding: ${theme.spacing(1)};
    color: ${theme.colors.neutrals.white};
  `}
  white-space: nowrap;
  :before {
    position: absolute;
    left: 50%;
    top: 100%;
    transform: translateX(-50%);
    content: '';
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 6px solid #074351;
  }
`;

export const AnimatedIconWrapper = styled.div<{ showOk: boolean; }>`
  width: 100%;
  height: 100%;
  overflow: hidden;
  & > div {
    transform: translateY(0);
    transition: transform 0.25s ease-out;
  }
  ${({ showOk }) => showOk ? `
    & > div {
      transform: translateY(-100%);
    }
  ` : ''}
`;

export const AnimatedIcon = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
